<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
    </div>
</template>
<script>
import Vue from 'vue'
// import 'vant/lib/icon/local.css'
// import '@evo-web/hua-design-mobile/lib/icon/index.css'
import '@evo-web/hua-design-mobile/lib/index.css'
import { validFn } from '@/constants/validator'
import {
    Button,
    Dialog,
    Loading,
    Form,
    Field,
    Toast,
    Icon,
    Swipe,
    SwipeItem,
    Lazyload,
    Image as VanImage,
    NavBar,
    Tab,
    Tabs,
    List,
    DatetimePicker,
    Cell,
    CellGroup,
    Popup,
    PullRefresh,
    Picker,
    RadioGroup,
    Radio,
    Checkbox,
    CheckboxGroup,
    Switch,
    Stepper,
    Uploader,
    Popover,
    IndexBar,
    IndexAnchor,
    Tag,
    NoticeBar,
    ImagePreview,
    Cascader
} from '@evo-web/hua-design-mobile' //'vant'
Toast.setDefaultOptions({ loading: { forbidClick: true }, duration: 1000 })
import resetAjax from '@/constants/ajaxReset'
import enumData from '@/constants/enum'
import api from '@/constants/api'

import datePicker from '@/components/datePicker'
import selectPicker from '@/components/selectPicker'
import gap from '@/components/gap'
import lwwRadio from '@/components/radio'
import lwwCheckbox from '@/components/checkbox'
import formItem from '@/components/formItem'
import VConsole from 'vconsole';
if(isDebuggerMode) {
    new VConsole();
}

Vue.component('lGap', gap)
Vue.component('datePicker', datePicker)
Vue.component('selectPicker', selectPicker)
Vue.component('lwwRadio', lwwRadio)
Vue.component('lwwCheckbox', lwwCheckbox)
Vue.component('formItem', formItem)

Vue.use(Button)
    .use(Form)
    .use(Field)
    .use(Dialog)
    .use(Toast)
    .use(Icon)
    .use(Loading)
    .use(Swipe)
    .use(SwipeItem)
    .use(Lazyload)
    .use(VanImage)
    .use(NavBar)
    .use(Tab)
    .use(Tabs)
    .use(List)
    .use(DatetimePicker)
    .use(Cell)
    .use(CellGroup)
    .use(Popup)
    .use(PullRefresh)
    .use(Picker)
    .use(RadioGroup)
    .use(Radio)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Switch)
    .use(Stepper)
    .use(Uploader)
    .use(Popover)
    .use(IndexBar)
    .use(IndexAnchor)
    .use(Tag)
    .use(NoticeBar)
    .use(ImagePreview)
    .use(Cascader)

export default {
    created() {
        Vue.prototype.valid = validFn(this)
        Vue.prototype.resetAjax = resetAjax(this)
        Vue.prototype.$enumData = enumData
    },
}
</script>
<style lang="less" >
@import './common.less';
body {
    font-size: 14px;
    background-color: #f8f8f8;
    -webkit-font-smoothing: antialiased;
}
/*::-webkit-scrollbar{width:0;height:1px}*/
/*::-webkit-scrollbar-thumb{border-radius:5px}*/
html,
body {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 100%;
    height: auto;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
}
#app {
    width: 100%;
    height: 100%;
}
</style>
